/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
/* eslint-disable */
import 'expose-loader?exposes=Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'jquery-touchswipe';
import './selectors';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';


import prestashop from 'prestashop';
import EventEmitter from 'events';
import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';
import $ from 'jquery';
import 'slick-slider';


/* eslint-enable */

// "inherit" EventEmitter
// eslint-disable-next-line
for (const i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const dropDownEl = $('.js-dropdown');
  const form = new Form();
  const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  const dropDown = new DropDown(dropDownEl);
  const topMenu = new TopMenu(topMenuEl);
  const productMinitature = new ProductMinitature();
  const productSelect = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();



  $('.carousel[data-touch="true"]').swipe({
    swipe(event, direction) {
      if (direction === 'left') {
        $(this).carousel('next');
      }
      if (direction === 'right') {
        $(this).carousel('prev');
      }
    },
    allowPageScroll: 'vertical',
  });
  
    $(".promotions.products-home-slider .products,.bestsellers.products-home-slider .products, .featured-products .products").each(function(){
        $(this).slick({
           // normal options...
           infinite: true,
           slidesToShow: 4,
           respondTo: 'min',
           
           responsive: [{

               breakpoint: 1024,
               settings: {
                 slidesToShow: 3,
                 infinite: true
               }

             }, {

               breakpoint: 600,
               settings: {
                 slidesToShow: 2,
                 dots: true,
                 arrows: true
               }

             }]
       });
    });
    
//    $(".toolsforbeauty.products-home-slider .manufacturer-container .products").slick({
//        // normal options...
//        infinite: true,
//        slidesToShow: 2,
//
//        responsive: [ {
//            breakpoint: 600,
//            settings: {
//              dots: true
//            }
//          }]
//      });
  
   $(document).on('click touch', '.toolsforbeauty .top-belt-menu .link', function(){
       $(".toolsforbeauty.products-home-slider .manufacturer-container .products").slick('unslick');
       $('.toolsforbeauty .top-belt-menu .link').removeClass('active');
       $('#home-manufacturers .manufacturer-container').removeClass('active');
       
       var id_cat = $(this).data('id-category');
       
       $(this).addClass('active');
       $('#home-manufacturers .manufacturer-container[data-id-category="' + id_cat + '"]').addClass('active');
       
       $(".toolsforbeauty.products-home-slider .manufacturer-container .products").slick({
        // normal options...
        infinite: true,
        slidesToShow: 2,

        responsive: [ {
            breakpoint: 600,
            settings: {
              dots: true,
              arrows: true
            }
          }]
      });
   })
   
   $('.toolsforbeauty .top-belt-menu .link').eq(0).click();
   
   if($(window).width() < 992) {
       $('.advantages-home').slick({
           slidesToShow: 1,
       });
   }
   
   
   $(".cart-suggestions .products").slick({
        // normal options...
        infinite: true,
        slidesToShow: 5,

        responsive: [{

            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              infinite: true
            }

          }, {

            breakpoint: 600,
            settings: {
              slidesToShow: 2 ,
              dots: true
            }

          }]
    });
});
